var map = {
	"./azure.png": 112,
	"./bootstrap.png": 805,
	"./csharp.png": 962,
	"./css.png": 758,
	"./docker.png": 644,
	"./dotnet.png": 947,
	"./efcore.png": 447,
	"./firebase.png": 264,
	"./html.png": 774,
	"./javascript.png": 305,
	"./mongo.png": 874,
	"./next.png": 628,
	"./postgre.png": 101,
	"./prisma.png": 588,
	"./rabbitmq.png": 781,
	"./react.png": 41,
	"./sqlserver.png": 954,
	"./tailwind.png": 22,
	"./typescript.png": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 728;